export const FILTER_OPERATOR = {
  EQUAL_TO: "EQUAL_TO",
  NOT_EQUAL_TO: "NOT_EQUAL_TO",
  NOT_EMPTY: "NOT_EMPTY",
  EMPTY: "EMPTY",
  CONTAINS: "CONTAINS",
  NOT_CONTAINS: "NOT_CONTAINS",
  LESS_THAN: "LESS_THAN",
  LESS_THAN_OR_EQUAL_TO: "LESS_THAN_OR_EQUAL_TO",
  GREATER_THAN: "GREATER_THAN",
  GREATER_THAN_OR_EQUAL_TO: "GREATER_THAN_OR_EQUAL_TO"
};
